<template>
  <table class="table table-sm table-striped layout_auto">
    <colgroup>
      <col style="width:25%">
      <col style="width:15%">
      <col style="width:60%">
    </colgroup>
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td><label>{{ $t('generic.details') }}</label></td>
    </tr>
    <tr v-for="failure in data" :key="failure.id">
      <td>{{ failure.id }}</td>
      <td>{{ failure.created_at | time }}</td>
      <td>{{ failure.details }}</td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'topUpFailuresTable',
  components: {},
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  computed: {}
};
</script>
<style>
.layout_auto {
  table-layout: auto;
  width: 100%;
}
</style>
